import { LitElement, html } from "lit-element";
import { property } from "lit/decorators.js";

class Register extends LitElement {
  errors: any = {};
  @property({ type: String }) message: any;

  protected createRenderRoot() {
    return this;
  }

  static get properties() {
    return {
      eg: { type: String },
      errors: { type: Object },
    };
  }

  clearError(field) {
    if (this.errors.field === field || this.errors.field === "email_password") {
      this.errors = {};
    }
  }
  render() {
    return html`
      <div class="auth-container">
        <h1>Create an account</h1>

        ${this.message
          ? html`<div class="form-success-message">${this.message}</div>`
          : html`
              <form @submit="${this.handleSubmit}">
                ${this.errors.field === "top"
                  ? html`<div class="form-error-message is-top">
                      ${this.errors.error}
                    </div>`
                  : ""}

                <div
                  class="form-group ${this.errors.field === "username"
                    ? "has-error"
                    : ""}"
                >
                  <label for="username">Username</label>
                  <input
                    type="text"
                    id="username"
                    name="username"
                    @input="${() => this.clearError("username")}"
                  />
                  ${this.errors.field === "username"
                    ? html`<span class="form-error-message"
                        >${this.errors.error}</span
                      >`
                    : ""}
                </div>

                <div
                  class="form-group ${this.errors.field === "email"
                    ? "has-error"
                    : ""}"
                >
                  <label for="email">Email</label>
                  <input
                    type="text"
                    name="email"
                    @input="${() => this.clearError("email")}"
                  />
                  ${this.errors.field === "email"
                    ? html`<span class="form-error-message"
                        >${this.errors.error}</span
                      >`
                    : ""}
                </div>

                <div
                  class="form-group ${this.errors.field === "password"
                    ? "has-error"
                    : ""}"
                >
                  <label for="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    @input="${() => this.clearError("password")}"
                  />
                  ${this.errors.field === "password"
                    ? html`<span class="form-error-message"
                        >${this.errors.error}</span
                      >`
                    : ""}
                </div>

                <div
                  class="form-group ${this.errors.field === "confirm_password"
                    ? "has-error"
                    : ""}"
                >
                  <label for="confirmPassword">Repeat Password</label>
                  <input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    @input="${() => this.clearError("confirmPassword")}"
                  />
                  ${this.errors.field === "confirmPassword"
                    ? html`<span class="form-error-message"
                        >${this.errors.error}</span
                      >`
                    : ""}
                </div>

                <div class="form-submit-section">
                  <button type="submit" class="form-submit form-button">
                    <span>Sign up</span>
                  </button>
                </div>
              </form>
            `}

        <p class="form-message">
          Already have an account?
          <a href="/" class="login-link">Log in</a>
        </p>
      </div>
    `;
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = new FormData(event.target);

    // // Gather form data
    const username = formData.get("username");
    const email = formData.get("email");
    const password = formData.get("password");
    const confirmPassword = formData.get("confirmPassword");

    // Prepare the data to send in the fetch request
    const requestData = {
      username,
      email,
      password,
      confirmPassword,
    };

    fetch(`${process.env.BASE_API_URL}/register`, {
      method: "POST",
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.error) {
          this.errors = data;
        } else {
          this.message = data.message || "Registration successful!";
        }
      })
      .catch((error) => {
        console.error("Error during registration:", error);
        alert(
          "An error occurred while processing your registration. Please try again later."
        );
      });
  }
  ƒ;
}

customElements.define("register-page", Register);
